import { create } from 'zustand';
import type { Session, User } from '@supabase/supabase-js';

interface AuthState {
  session: Session | null;
  user: User | null;
  profile: {
    id: string;
    tenant_id: string;
    email: string;
    full_name: string;
    avatar_url: string | null;
    role: 'admin' | 'manager' | 'employee';
  } | null;
  isLoading: boolean;
  setSession: (session: Session | null) => void;
  setProfile: (profile: AuthState['profile']) => void;
  setLoading: (loading: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  user: null,
  profile: null,
  isLoading: true,
  setSession: (session) =>
    set({ session, user: session?.user ?? null }),
  setProfile: (profile) => set({ profile }),
  setLoading: (isLoading) => set({ isLoading }),
  clear: () =>
    set({ session: null, user: null, profile: null, isLoading: false }),
}));
